import { IconArrosDifs, IconPeopleProjects } from "../../../../../../icons";
import "./index.scss";

export function BodyMiniCardList({ client }) {
  return (
    <>
      <div className="pt-4 pr-2 pb-2">
        <div className="div-row justify-between">
          <div className="div-row">
            <span className="card-arrows-icon">{IconArrosDifs}</span>
            <span className="-mt-2 card-info-body"> projetos</span>
          </div>
          <span className="card-infos-number">{client?.projects}</span>
        </div>

        <div className="div-row justify-between">
          <div className="div-row">
            <span className="card-people-icon">{IconPeopleProjects}</span>
            <span className="-mt-1 card-info-body">Profissionais ativos</span>
          </div>
          <span className="card-infos-number">{client?.collaborators}</span>
        </div>
      </div>
    </>
  );
}
